module.exports = __webpack_public_path__ + "img/2023_ram-2500-01.e3cde380.jpg";